import React, { useEffect, useState } from "react";
import { 
    Card, 
    Container, 
    IconButton, 
    Modal,
    Stack,
    Box
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import AddIcon from "@mui/icons-material/Add";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import HoaPropertyViolationDeleteListItem from "./hoa-property-violation-delete-list-item";
import { sortViolations } from "../../../utility/helper";

const HoaPropertyViolationStagesModal = ({
        isViewOnly,
        addNewStageBtnClick,
        updateAllNoticeStatus,
        onViolationStageClick,
        isViolationStagesModalOpen,
        setIsViolationStagesModalOpen,
        violationList,
        setViolationLists,
        violation,
        onCloseViolationStageModal,
        setviolation,
        reorderedViolations,
	    setReorderedViolations
    }: any) => {

    const [violationPreviousStagesList, setViolationPreviousStagesList] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [deleteFromListIndex, setDeleteFromListIndex] = useState(null);

	const onDeleteModalClose = (shouldStageModalStayOpen: any = true) => {
		setIsDeleteModalOpen(false);
        setIsViolationStagesModalOpen(shouldStageModalStayOpen);
	}

    useEffect(() => {
        if (isViolationStagesModalOpen && Array.isArray(violationList) && violationList.length > 0 && violation) {
            const childViolationIdsList = violation.childViolationIdsList;
            let previousStages:any = [];

            if (Array.isArray(childViolationIdsList) && childViolationIdsList.length > 0) {
                previousStages = violationList.filter((item:any) => {
                    return childViolationIdsList.includes(item.objectId);
                });
            }

            previousStages = sortViolations(previousStages)

            setViolationPreviousStagesList(previousStages);
        }
    }, [violationList, violation])

    const onDeleteClick = (violationToBeDeleted: any) => {
        let listIndex = -1;
        violationList.forEach((item: any, index: number) => {
            if (item.objectId === violationToBeDeleted.objectId) {
                listIndex = index;
            }
        });
        if (listIndex > -1) {
            setDeleteFromListIndex(listIndex);
            setIsViolationStagesModalOpen(false);   
            setIsDeleteModalOpen(true);
        }
	}

    const handleDelete = () => {
        let violationListCopy = JSON.parse(JSON.stringify(violationList));
        let shouldStageModalStayOpen = true;
        let isParentViolation = false;
		if(Array.isArray(violationListCopy) && deleteFromListIndex < violationListCopy.length) {
            if (Array.isArray(violationListCopy[deleteFromListIndex].childViolationIdsList) && violationListCopy[deleteFromListIndex].childViolationIdsList.length > 0) {
                // check if parent violation then make a child new parent
                isParentViolation = true;
                const newParentViolationId = violationListCopy[deleteFromListIndex].childViolationIdsList[0];
                let newParentIndex = -1;
                violationListCopy.forEach((item:any, index: number) => {
                    if (item.objectId === newParentViolationId) {
                        newParentIndex = index;
                    }
                });

                const newChildViolationList = violationListCopy[deleteFromListIndex].childViolationIdsList.filter((item:any) => {
                    return item != newParentViolationId;
                });

                if (newParentIndex > -1) {
                    violationListCopy[newParentIndex].childViolationIdsList = newChildViolationList;
                    violationListCopy[deleteFromListIndex].childViolationIdsList = [];

                    setviolation(violationListCopy[newParentIndex]);
                }
            }
            else {
                // check if child violation then remove this child
                let parentViolationIndex = -1;
                violationListCopy.forEach((item:any, index:number) => {
                    if (Array.isArray(item.childViolationIdsList) && item.childViolationIdsList.includes(violationListCopy[deleteFromListIndex].objectId)) {
                        parentViolationIndex = index;
                    }
                });

                if (parentViolationIndex > -1) {
                    const newChildViolationList = violationListCopy[parentViolationIndex].childViolationIdsList.filter((item:any) => {
                        return item != violationListCopy[deleteFromListIndex].objectId;
                    });

                    violationListCopy[parentViolationIndex].childViolationIdsList = newChildViolationList;
                }
                else {
                    isParentViolation = true;
                    setviolation({});
                    shouldStageModalStayOpen = false;
                }
            }


			violationListCopy[deleteFromListIndex].isDeleted = true;
            violationListCopy[deleteFromListIndex].isParentViolation = isParentViolation;

			setViolationLists(violationListCopy);
		}
		onDeleteModalClose(shouldStageModalStayOpen);
    }

    const updateViolationOrder = () => {
        const oldParentViolation = JSON.parse(JSON.stringify(violation));
        oldParentViolation.childViolationIdsList = [];

        const totalViolationList = [oldParentViolation, ...violationPreviousStagesList];
        const sortedViolationList = sortViolations(totalViolationList);

        const newParentViolation = sortedViolationList[0];
        sortedViolationList.shift();

        const newChildViolationIdsList:any = []; 
        sortedViolationList.map((item:any) => {
            newChildViolationIdsList.push(item.objectId);
        });

        newParentViolation.childViolationIdsList = newChildViolationIdsList;

        if (oldParentViolation.objectId != newParentViolation.objectId) {
            const violationListCopy = JSON.parse(JSON.stringify(violationList));

            for (const item of violationListCopy) {
                if (item.objectId == oldParentViolation.objectId) {
                    item.childViolationIdsList = [];
                }
                else if (item.objectId == newParentViolation) {
                    item.childViolationIdsList = newChildViolationIdsList;
                }
            }

            setReorderedViolations([...reorderedViolations, newParentViolation.objectId]);
            setViolationLists(violationListCopy);
            setviolation(newParentViolation);
        }
    }

    const shouldDisableAddNewStage = () => {
        return Array.isArray(reorderedViolations) && reorderedViolations.includes(violation.objectId);
    }

    const showHoaId = (item: any) => {
        if (Array.isArray(item?.hoaInfo) && item.hoaInfo.length > 0 && item.hoaInfo[0].hoaId) {
            return item.hoaInfo[0].hoaId
        }
        else {
            return "N/A";
        }
    }

	return (
        <>
		<Modal open={isViolationStagesModalOpen}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "5px",
					padding: "0px",
                    overflowX: 'hidden'
				}}
			>
                {
                    !violation.isDeleted ?
                    <>
                        <div style={{ background: "#EFF4FC", display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', padding: '17px 17px 0px 17px' }}>
                                    <span style={{ fontSize: '16px', fontWeight: 500, padding: '10px 10px 10px 0px' }}>
                                        {violation.violation}
                                    </span>
                                    <div style={{ height: '30px', padding: '8px 5px 0px 5px', color: '#FFFFFF', borderRadius: '3px', textAlign: 'center', background: violation.noticeStatus === 'active' ? '#6FCF97' : '#ffb600' }}>
                                        {violation.noticeStatus === 'active' ? 'Active' : 'Resolved'}
                                    </div>
                                </div>
                                {
                                    !isViewOnly && violation.objectId &&
                                    <div style={{padding: '27px 0px 0px 17px', cursor: 'pointer'}} onClick={updateViolationOrder}>
                                        <SwapVertIcon />
                                    </div>
                                }
                                <div style={{padding: '27px 17px 0px 17px', cursor: 'pointer'}} onClick={onCloseViolationStageModal}>
                                    <CloseIcon />
                                </div>
                            </div>
                            <span style={{ fontSize: '12px', color: '#787878', padding: "0px 0px 17px 17px", fontWeight: 500 }}>Last Updated On: {violation.updatedAt ? new Date(violation.updatedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}</span>
                        </div>
                        <Stack style={{ padding: '24px' }}>
                            <span style={{ color: '#787878', fontSize: '12px', marginBottom: '8px' }}>Current</span>
                            <Card
                                variant="outlined"
                                style={{ background: "#FAFAFA" }}
                                className="violation-card-container"
                            >
                                <Stack direction={"row"} justifyContent={'space-between'}>
                                    <div style={{display:'flex', cursor: 'pointer', width: '100%'}} onClick={()=> onViolationStageClick(violation)}>
                                        {/* <span style={{marginRight: '12px', color: '#9F9F9F'}}>{index+1}</span> */}
                                        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                           <Box display="flex" alignItems="center" justifyContent="space-between">
                                                <Box>
                                                    <Box style={{ fontSize: '12px', fontWeight: 500 }}>
                                                      {violation.violation}
                                                    </Box>
                                                    <Box style={{ fontSize: '12px', color: '#9F9F9F', paddingTop: '4px' }}>
                                                      Added On : {violation.createdAt ? new Date(violation.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}
                                                    </Box>
                                                    </Box>

                                                    {violation?.violationType && (
                                                    <Box
                                                        sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: violation.violationType === 'HOA Violation' ? '#e1d1ed' : '#bad9b0',
                                                        px: '8px',
                                                        py: '2px',
                                                        lineHeight: 1.5,
                                                        borderRadius: '4px',
                                                        alignSelf: 'flex-start'
                                                        }}
                                                        >
                                                        {violation.violationType}
                                                    </Box>
                                                    )}
                                                </Box>

                                            <div style={{display: 'flex', width: '100%', paddingTop: '10px'}}>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '20%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Hoa ID</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{showHoaId(violation)}</span>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Violation ID</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{violation.objectId ? `${violation.propertyId}-${violation.objectId}` : 'N/A'}</span>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '30%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Stage</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{violation.stage || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        !isViewOnly &&
                                        (
                                            <div style={{ display:'flex', alignItems:'start', justifyContent:'center', paddingTop: "0px"}}>
                                                <IconButton style={{cursor: 'pointer', paddingTop: "0px"}} onClick={()=> onDeleteClick(violation)}>
                                                    <DeleteOutlineIcon sx={{paddingTop: "0px"}} />
                                                </IconButton>
                                            </div>
                                        )
                                    }
                                </Stack>
                            </Card>
                        </Stack>
                    </>
                    :
                    <Card
                        variant="outlined"
                        style={{ background: "#FAFAFA" }}
                        className="violation-card-container"
                    >
                        <Stack direction={"row"} justifyContent={'space-between'}>
                            <div style={{display:'flex'}}>
                                <span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item found !`}</span>
                            </div>
                        </Stack>
                    </Card>
                }
                <Stack style={{ padding: '24px' }}>
                <span style={{ color: '#787878', fontSize: '12px', marginBottom: '8px' }}>Previous</span>
                {
                    violationPreviousStagesList && violationPreviousStagesList.length > 0 ? violationPreviousStagesList.map((item: any, index: number) => {
                        if(!item.isDeleted){
                            return (
                            <Card
                                variant="outlined"
                                style={{ background: "#FAFAFA" }}
                                className="violation-card-container"
                            >
                                <Stack direction={"row"} justifyContent={'space-between'}>
                                    <div style={{display:'flex', cursor: 'pointer', width: '100%'}} onClick={()=> onViolationStageClick(item)}>
                                        <span style={{marginRight: '12px', color: '#9F9F9F'}}>{violationPreviousStagesList.length - index}</span>
                                        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                            <span style={{fontSize: '12px', fontWeight: 500}} >{item.violation}</span>
                                            <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>Added On : {item.createdAt ? new Date(item.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}</span>
                                            <div style={{display: 'flex', width: '100%', paddingTop: '10px'}}>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '20%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Hoa ID</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{showHoaId(item)}</span>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Violation ID</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.objectId ? `${item.propertyId}-${item.objectId}` : 'N/A'}</span>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '30%'}}>
                                                    <span style={{fontSize: '12px', fontWeight: 500}} >Stage</span>
                                                    <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.stage || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        !isViewOnly &&
                                        (
                                            <div style={{ display:'flex', alignItems:'center', justifyContent:'center'}}>
                                                <IconButton style={{cursor: 'pointer'}} onClick={()=> onDeleteClick(item)}>
                                                    <DeleteOutlineIcon />
                                                </IconButton>
                                            </div>
                                        )
                                    }
                                </Stack>
                            </Card>
                            )
                        }
                    }) :
                    <Card
                        variant="outlined"
                        style={{ background: "#FAFAFA" }}
                        className="violation-card-container"
                    >
                        <Stack direction={"row"} justifyContent={'space-between'}>
                            <div style={{display:'flex'}}>
                                <span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item Added Yet !`}</span>
                            </div>
                        </Stack>
                    </Card>
                }                
                </Stack>
                {
                    !isViewOnly &&
                    (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #0000001f', padding: '24px'}}>
                            {
                                violation.noticeStatus == 'active' ? 
                                    <LoadingButton
                                        onClick={() => updateAllNoticeStatus('resolved')}
                                        style={{ marginRight: '10px', textTransform: "capitalize", border: '1px solid #E8E8E8', color: '#3E3E3E' }}
                                        startIcon={<DoneAllIcon color="primary" />}
                                        variant="outlined"
                                    >
                                        Mark As Resolved
                                    </LoadingButton>
                                    :
                                    <LoadingButton
                                        onClick={() => updateAllNoticeStatus('active')}
                                        style={{ marginRight: '10px', textTransform: "capitalize", border: '1px solid #E8E8E8', color: '#3E3E3E' }}
                                        startIcon={<DoneAllIcon color="primary" />}
                                        variant="outlined"
                                    >
                                        Mark As active
                                    </LoadingButton>
                            }
                            
                            <LoadingButton
                                disabled={!violation.objectId || shouldDisableAddNewStage()}
                                onClick={() => addNewStageBtnClick()}
                                style={{ textTransform: "capitalize", border: '1px solid #E8E8E8', color: violation.objectId && !shouldDisableAddNewStage() ? '#3E3E3E' : '#E8E8E8' }}
                                startIcon={<AddIcon color="primary" />}
                                variant="outlined"
                            >
                                Add New Stage
                            </LoadingButton>
                        </div>
                    )
                }
			</Container>
		</Modal>
        {
            !isViewOnly &&
            (
                <HoaPropertyViolationDeleteListItem open={isDeleteModalOpen} onClose={onDeleteModalClose} handleDelete={handleDelete} />
            )
        }
        </>
	);
};

export default HoaPropertyViolationStagesModal;